export default __webpack_public_path__ + "media/images/icons/icon-reset-fab8fe84d0a4f6dcdb34c7caa42c15bd.svg";